export default __webpack_public_path__ + "static/media/logo.eca4454f.png";